import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { getTrackListReportList } from 'models/weaknessTrainTrackReport';
import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';

// import InpatientListInner from './Inner';

const routes: CustomRoute = {
	path: '/weakness-train-track',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'inpatientList' */ './component')],
			render: ([WeaknessTrainTrackReport]) => <WeaknessTrainTrackReport />,
			onEnter: async ({ store, next }) => {
				console.log('on Weakness Train Track Page');
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.WEAKNESS_TRAIN_TRACK}`);
				if (allowEnter) {
					await store.dispatch(getTrackListReportList());
				}
				const children = await next();
				return children;
			},
		},
		// InpatientListInner,
	],
};
export default routes;
